module.exports = __webpack_public_path__ + "static/img/button3.1556039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/button3.png
// module id = lCQM
// module chunks = 4